import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CustomIcons } from '@shared/models/custom-icons';
import { ServerLinks } from '@shared/services/server-links';
import { ServerLinkName } from '@shared/models/server-links-model';
import { TranslateService } from '@ngx-translate/core';
import { Locale } from '@shared/models/locale';
import { tap } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { LangChangeEvent } from '@ngx-translate/core/lib/translate.service';
import { SmallCardData } from '../../models/smal-card';
import { CatalogItemsDataRouting } from '../../../data/modules/catalog-items-data/models/catalog-items-data-routing';

@Component({
  selector: 'app-small-card',
  templateUrl: './small-card.component.html',
  styleUrls: ['./small-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SmallCardComponent implements OnInit {
  @Input() public data: SmallCardData | any;
  @Input() public clickable = false;
  @Input() public hasShowDownloads: boolean;
  public icons = CustomIcons;
  public openData = 'opendata';
  public fileLink: string;
  public passportRoute = CatalogItemsDataRouting.Passport;
  public langChange$: Observable<LangChangeEvent>;

  public route: string;
  constructor(serverLinks: ServerLinks, private translateService: TranslateService) {
    this.fileLink = serverLinks.getLink(ServerLinkName.DownloadFile);
  }

  private setLocale(lang: Locale): void {
    if (this.data) {
      if (lang === Locale.RU_RU) {
        this.route = `/${this.openData}/${this.data.datasetId}`;
        this.data.title = this.data.titleRu;
        this.data.text = this.data.textRu;
      } else {
        this.route = `/${this.openData}/${this.data.datasetId}/${this.passportRoute}`;
        this.data.text = this.data.textEng;
        this.data.title = this.data.titleEng;
      }
    }
  }
  public ngOnInit(): void {
    this.setLocale(this.translateService.currentLang as Locale);
    this.langChange$ = this.translateService.onLangChange.pipe(
      tap(res => {
        this.setLocale(res.lang as Locale);
      })
    );
  }
}
